import axios from "axios";
import { ticketBaseURL } from "../config/api";

export const getMyCdirInvoicesByTenantId = async (tenantId: string, page: number, size: number) => {
    return await getFetch(`mycdirInvoice/GetMycdirInvoicesPagingByTenantId/${tenantId},${page},${size}`)
}

export const getMyCdirInvoiceDetails = async (invoiceId: string) => {
    return await getFetch(`mycdirInvoice/GetInvoiceDetails/${invoiceId}`)
}

export const getWalletInvoiceDetails = async (invoiceId: string) => {
    return await getFetch(`mycdirInvoice/GetWalletInvoiceDetails/${invoiceId}`)
}

const getFetch = async (url: string, params = {}) => {
    return await axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}